import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, UserIcon, ArrowRightIcon } from 'lucide-react';
const blogPosts = [{
  id: 1,
  title: 'The Healing Power of Lavender Essential Oil',
  excerpt: 'Discover the many therapeutic benefits of lavender oil and how to incorporate it into your daily wellness routine.',
  image: 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=1080&auto=format&fit=crop',
  date: 'May 15, 2023',
  author: 'Sarah Kimani',
  category: 'Wellness',
  slug: 'healing-power-of-lavender'
}, {
  id: 2,
  title: 'Essential Oils for Better Sleep: A Natural Approach',
  excerpt: 'Learn how to create the perfect bedtime routine with essential oils that promote relaxation and deep sleep.',
  image: 'https://images.unsplash.com/photo-1505992525839-8040fba23095?q=80&w=1080&auto=format&fit=crop',
  date: 'June 2, 2023',
  author: 'David Mwangi',
  category: 'Lifestyle',
  slug: 'essential-oils-better-sleep'
}, {
  id: 3,
  title: 'Sourcing Essential Oils: Our Journey Through Kenya',
  excerpt: 'Follow our team as we explore the rich botanical landscapes of Kenya to source the finest ingredients for our oils.',
  image: 'https://images.unsplash.com/photo-1580757468214-c73f7062a5cb?q=80&w=1080&auto=format&fit=crop',
  date: 'June 28, 2023',
  author: 'James Omondi',
  category: 'Behind the Scenes',
  slug: 'sourcing-essential-oils-kenya'
}, {
  id: 4,
  title: 'DIY Essential Oil Blends for Your Home Diffuser',
  excerpt: 'Create your own signature scents with these easy-to-follow recipes for your home diffuser.',
  image: 'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=1080&auto=format&fit=crop',
  date: 'July 10, 2023',
  author: 'Grace Wanjiku',
  category: 'DIY',
  slug: 'diy-essential-oil-blends'
}, {
  id: 5,
  title: 'Essential Oils for Stress Relief and Anxiety',
  excerpt: 'Discover which essential oils can help reduce stress and anxiety, and the best ways to use them.',
  image: 'https://images.unsplash.com/photo-1519710164239-da123dc03ef4?q=80&w=1080&auto=format&fit=crop',
  date: 'August 5, 2023',
  author: 'Esther Njeri',
  category: 'Wellness',
  slug: 'essential-oils-stress-relief'
}, {
  id: 6,
  title: 'The Science Behind Essential Oils: How They Work',
  excerpt: 'A deep dive into the chemistry of essential oils and how they affect our bodies and minds.',
  image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?q=80&w=1080&auto=format&fit=crop',
  date: 'September 12, 2023',
  author: 'Dr. Peter Kamau',
  category: 'Education',
  slug: 'science-behind-essential-oils'
}];
const categories = ['All', 'Wellness', 'Lifestyle', 'DIY', 'Education', 'Behind the Scenes'];
const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const filteredPosts = selectedCategory === 'All' ? blogPosts : blogPosts.filter(post => post.category === selectedCategory);
  return <div className="bg-[#f8f9f4] min-h-screen w-full" data-id="element-610">
      {/* Hero Section */}
      <div className="bg-[#2e7d32] text-white py-16" data-id="element-611">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-612">
          <h1 className="text-4xl font-bold mb-4" data-id="element-613">Our Blog</h1>
          <p className="text-lg max-w-2xl" data-id="element-614">
            Explore our articles about essential oils, wellness tips, and the
            stories behind our products.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-615">
        {/* Category filter */}
        <div className="mb-10 flex flex-wrap gap-2 justify-center" data-id="element-616">
          {categories.map(category => <button key={category} onClick={() => setSelectedCategory(category)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${selectedCategory === category ? 'bg-[#2e7d32] text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`} data-id="element-617">
              {category}
            </button>)}
        </div>
        {/* Featured post */}
        {filteredPosts.length > 0 && <div className="mb-12" data-id="element-618">
            <Link to={`/blog/${filteredPosts[0].slug}`} className="block" data-id="element-619">
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300" data-id="element-620">
                <div className="md:flex" data-id="element-621">
                  <div className="md:w-1/2" data-id="element-622">
                    <div className="h-64 md:h-full overflow-hidden" data-id="element-623">
                      <img src={filteredPosts[0].image} alt={filteredPosts[0].title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" onError={e => {
                    e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=1080&auto=format&fit=crop';
                  }} data-id="element-624" />
                    </div>
                  </div>
                  <div className="md:w-1/2 p-6 md:p-8 flex flex-col justify-center" data-id="element-625">
                    <div className="uppercase tracking-wide text-sm text-[#2e7d32] font-semibold mb-2" data-id="element-626">
                      {filteredPosts[0].category}
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4 hover:text-[#2e7d32] transition-colors" data-id="element-627">
                      {filteredPosts[0].title}
                    </h2>
                    <p className="text-gray-600 mb-6" data-id="element-628">
                      {filteredPosts[0].excerpt}
                    </p>
                    <div className="flex items-center text-gray-500 text-sm mb-4" data-id="element-629">
                      <CalendarIcon className="h-4 w-4 mr-2" data-id="element-630" />
                      <span data-id="element-631">{filteredPosts[0].date}</span>
                      <span className="mx-2" data-id="element-632">•</span>
                      <UserIcon className="h-4 w-4 mr-2" data-id="element-633" />
                      <span data-id="element-634">{filteredPosts[0].author}</span>
                    </div>
                    <div className="inline-flex items-center text-[#2e7d32] font-medium group" data-id="element-635">
                      Read More
                      <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-636" />
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>}
        {/* Blog posts grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-637">
          {filteredPosts.slice(1).map(post => <Link key={post.id} to={`/blog/${post.slug}`} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col h-full" data-id="element-638">
              <div className="h-48 overflow-hidden" data-id="element-639">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" onError={e => {
              e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
            }} data-id="element-640" />
              </div>
              <div className="p-6 flex-grow" data-id="element-641">
                <div className="uppercase tracking-wide text-xs text-[#2e7d32] font-semibold mb-2" data-id="element-642">
                  {post.category}
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-3 hover:text-[#2e7d32] transition-colors" data-id="element-643">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3" data-id="element-644">
                  {post.excerpt}
                </p>
              </div>
              <div className="px-6 pb-6" data-id="element-645">
                <div className="flex items-center text-gray-500 text-sm mb-3" data-id="element-646">
                  <CalendarIcon className="h-4 w-4 mr-2" data-id="element-647" />
                  <span data-id="element-648">{post.date}</span>
                  <span className="mx-2" data-id="element-649">•</span>
                  <UserIcon className="h-4 w-4 mr-2" data-id="element-650" />
                  <span data-id="element-651">{post.author}</span>
                </div>
                <div className="inline-flex items-center text-[#2e7d32] font-medium group" data-id="element-652">
                  Read More
                  <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-653" />
                </div>
              </div>
            </Link>)}
        </div>
        {filteredPosts.length === 0 && <div className="text-center py-12" data-id="element-654">
            <p className="text-gray-600 text-lg" data-id="element-655">
              No blog posts found in this category.
            </p>
            <button onClick={() => setSelectedCategory('All')} className="mt-4 text-[#2e7d32] font-medium hover:underline" data-id="element-656">
              View all posts
            </button>
          </div>}
      </div>
    </div>;
};
export default Blog;